// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offers{
    width: 65%;
    height: 60vh;
    display: flex;
    margin: auto;
    padding: 0px 140px;
    margin-bottom: 150px;
    background: linear-gradient(180deg, #fde1ff 0%, #e1ffea22 60%);
}
.offers-left{
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

}
.offers-left h1{
    color: #171717;
    font-size: 80px;
    font-weight: 600;
}
.offers-left p{
    color: #171717;
    font-size: 22px;
    font-weight: 600;
}
.offers-left button{
    width: 282px;
    height: 70px;
    border-radius: 35px;
    background: #ff4141;
    border: none;
    color: white;
    font-size: 22px;
    font-weight: 500;
     margin-top: 30px;
     cursor: pointer;
}
.offers-right{
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 50px;
}
@media(max-width:1280px){
    .offers{
        padding: 0px 80px;
        margin-bottom: 120px;
    }
    .offers-left h1{
        font-size: 40px;
    }
    .offers-left p{
        font-size: 18px;
    }
    .offers-right img{
        width: 300px;
    }
    .offers-left button{
        width: 220px;
        height: 50px;
        font-size: 18px;
    }
    .offers-right{
        padding-top: 30px;
    }
}
@media(max-width:1024px){
    .offers{
        padding: 0px 60px;
        margin-bottom: 80px;
        height: 40vh;
    }
    .offers-left h1{
        font-size: 30px;
    }
    .offers-left p{
        font-size: 16px;
    }
    .offers-right img{
        width: 200px;
    }
    .offers-left button{
        width: 160px;
        height: 40px;
        font-size: 16px;
    }
    .offers-right{
        padding-top: 10px;
    }
}
@media(max-width:800px){
    .offers{

        margin-bottom: 60px;

    }
    .offers-left h1{
        font-size: 22px;
    }
    .offers-left p{
        font-size: 13px;
    }
    .offers-right img{
        width: 180px;
    }
    .offers-left button{
        width: 140px;
        height: 30px;
        font-size: 12px;
    }

}
@media(max-width:500px){
    .offers{
      
        margin-bottom: 50px;
        height: 25vh;
    }
    .offers-left h1{
        font-size: 16px;
    }
    .offers-left p{
        font-size: 10px;
    }
    .offers-right img{
        width: 120px;
    }
    .offers-left button{
        width: 120px;
        height: 25px;
        font-size: 10px;
        margin-top: 12px;
    }
    
}
`, "",{"version":3,"sources":["webpack://./src/Components/Offers/Offers.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,8DAA8D;AAClE;AACA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;;AAE3B;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;KACf,gBAAgB;KAChB,eAAe;AACpB;AACA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,iBAAiB;QACjB,mBAAmB;QACnB,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;;QAEI,mBAAmB;;IAEvB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;;AAEJ;AACA;IACI;;QAEI,mBAAmB;QACnB,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;;AAEJ","sourcesContent":[".offers{\n    width: 65%;\n    height: 60vh;\n    display: flex;\n    margin: auto;\n    padding: 0px 140px;\n    margin-bottom: 150px;\n    background: linear-gradient(180deg, #fde1ff 0%, #e1ffea22 60%);\n}\n.offers-left{\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n}\n.offers-left h1{\n    color: #171717;\n    font-size: 80px;\n    font-weight: 600;\n}\n.offers-left p{\n    color: #171717;\n    font-size: 22px;\n    font-weight: 600;\n}\n.offers-left button{\n    width: 282px;\n    height: 70px;\n    border-radius: 35px;\n    background: #ff4141;\n    border: none;\n    color: white;\n    font-size: 22px;\n    font-weight: 500;\n     margin-top: 30px;\n     cursor: pointer;\n}\n.offers-right{\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding-top: 50px;\n}\n@media(max-width:1280px){\n    .offers{\n        padding: 0px 80px;\n        margin-bottom: 120px;\n    }\n    .offers-left h1{\n        font-size: 40px;\n    }\n    .offers-left p{\n        font-size: 18px;\n    }\n    .offers-right img{\n        width: 300px;\n    }\n    .offers-left button{\n        width: 220px;\n        height: 50px;\n        font-size: 18px;\n    }\n    .offers-right{\n        padding-top: 30px;\n    }\n}\n@media(max-width:1024px){\n    .offers{\n        padding: 0px 60px;\n        margin-bottom: 80px;\n        height: 40vh;\n    }\n    .offers-left h1{\n        font-size: 30px;\n    }\n    .offers-left p{\n        font-size: 16px;\n    }\n    .offers-right img{\n        width: 200px;\n    }\n    .offers-left button{\n        width: 160px;\n        height: 40px;\n        font-size: 16px;\n    }\n    .offers-right{\n        padding-top: 10px;\n    }\n}\n@media(max-width:800px){\n    .offers{\n\n        margin-bottom: 60px;\n\n    }\n    .offers-left h1{\n        font-size: 22px;\n    }\n    .offers-left p{\n        font-size: 13px;\n    }\n    .offers-right img{\n        width: 180px;\n    }\n    .offers-left button{\n        width: 140px;\n        height: 30px;\n        font-size: 12px;\n    }\n\n}\n@media(max-width:500px){\n    .offers{\n      \n        margin-bottom: 50px;\n        height: 25vh;\n    }\n    .offers-left h1{\n        font-size: 16px;\n    }\n    .offers-left p{\n        font-size: 10px;\n    }\n    .offers-right img{\n        width: 120px;\n    }\n    .offers-left button{\n        width: 120px;\n        height: 25px;\n        font-size: 10px;\n        margin-top: 12px;\n    }\n    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
